import { GAC_SEARCH_INITIATED, GAC_SEARCH_RESULTS_READY, GAC_SUGGESTION_INPUT_ERROR, GAC_SUGGESTION_SELECTED, GAC_SET_REAL_NAMES, GAC_SET_SEO_LABEL } from './geosuggestion.types';
export var initiateGacSuggestionsSearch = function initiateGacSuggestionsSearch(searchInput) {
  return {
    type: GAC_SEARCH_INITIATED,
    searchInput: searchInput
  };
};
export var gacSearchResultReady = function gacSearchResultReady(gacOverAllInfo) {
  return {
    type: GAC_SEARCH_RESULTS_READY,
    gacOverAllInfo: gacOverAllInfo
  };
};
export var gacSuggestionSelected = function gacSuggestionSelected(gacOverAllInfo) {
  return {
    type: GAC_SUGGESTION_SELECTED,
    gacOverAllInfo: gacOverAllInfo
  };
};
export var setSuggestionInputError = function setSuggestionInputError(gacOverAllInfo) {
  return {
    type: GAC_SUGGESTION_INPUT_ERROR,
    gacOverAllInfo: gacOverAllInfo
  };
};
export var setGeoPathRealNames = function setGeoPathRealNames(names) {
  return {
    type: GAC_SET_REAL_NAMES,
    names: names
  };
};
export var setSeoLabel = function setSeoLabel(seoLabel) {
  return {
    type: GAC_SET_SEO_LABEL,
    seoLabel: seoLabel
  };
};